import { assetUrl } from "~/utils/assetUrl"
import { archetypeImageUrl } from "~/utils/archetypeImageUrl"

interface SignupHeroProps {
  dogName: string
  archetypeName: string
  portraitIcon: string
}

export function SignupHero({ dogName, archetypeName, portraitIcon }: SignupHeroProps) {
  const identityLabel = `${dogName}, ${archetypeName}`

  return (
    <div className="flex flex-col items-center gap-3">
      <div className="h-28 w-28 overflow-hidden rounded-full border-4 border-white shadow-[0_8px_24px_rgba(0,0,0,0.12)]">
        <img
          src={assetUrl(`/images/archetypes/portraits/${portraitIcon}`)}
          alt={`Portrait for ${archetypeName} archetype`}
          className="h-full w-full object-cover"
        />
      </div>
      <div
        className="flex w-full max-w-xs items-center gap-3 rounded-xl border border-[var(--color-divider)] bg-[var(--color-surface-card)] px-4 py-3 text-left shadow-sm"
        aria-label={identityLabel}
      >
        <img
          src={archetypeImageUrl(portraitIcon, "logos")}
          alt={`${archetypeName} archetype icon`}
          className="h-10 w-10 shrink-0 object-contain"
        />
        <div className="min-w-0">
          <p className="truncate text-base font-semibold text-[var(--color-text-primary)]">{dogName}</p>
          <p className="truncate text-sm text-[var(--color-text-secondary)]">{archetypeName}</p>
        </div>
      </div>
    </div>
  )
}
